import React from 'react';
// import { Redirect } from 'react-router';
import {Button,Badge, Form, Label, Input} from 'reactstrap';
import { getAudioCountServer,getCorrectAudioListServer,
    getSpecificAudioServer,getWrongAudioListServer,
    deleteAudioWithId, changeVerificationResult,getAudioVerifyCountServer } from '../functions/adminFunctions';

class AdminAudioTools extends React.Component{
    constructor(props){
        super(props);
        this.state={
            days:"1",
            audioCustomDays:1,
            activeAudioList:[],
            maxAudio:10,
            // States for finding specific audio
            specificAudio:"",
            retrievedAudio:[],
            specificAudioDiv:"",
            audioCount:"",
            audioVerfiedCount:""
        }
        this.verifyAudio = React.createRef();
    }

    // User Range Queries
    audioForDays = (event) =>{
        console.log(event.target);
        if(event.target.name!=="inputDays"){
            this.setState({
                days:event.target.value,
                audioCustomDays:event.target.value==="custom"?365:event.target.value
            });
        }
        else{
            this.setState({
                audioCustomDays:event.target.value
            });
        }
    }

    specificAudio = (event) =>{
        this.setState({
            specificAudio:event.target.value
        })
    }

    changeLimit=(event)=>{
        this.setState({
            maxAudio:event.target.value
        });
    }

    // get count of audios recorded in a fixed Interval
    getAudioCount = () =>{
        getAudioCountServer(24*this.state.audioCustomDays)
        .then((count)=>{
            this.setState({
                audioCount:"Audios Recorded: "+count
            })
        })
        .catch((err)=>console.log("Error Fetching Audio Count"))
    }

    // get count of number of audios verified in the specifed time frame
    getAudioVerifiedCount = () =>{
        getAudioVerifyCountServer(24*this.state.audioCustomDays)
        .then((count)=>{
            this.setState({
                audioVerfiedCount:"Audios Verified: "+count
            })
        })
        .catch((err)=>console.log("Error Fetching Audio Count"))
    }

    // get a specific file
    getSpecificAudio = () =>{
        this.setState({
            retrievedAudio:[]
        });
        getSpecificAudioServer(this.state.specificAudio)
        .then((audio)=>{
            this.setState({
                retrievedAudio:this.state.retrievedAudio.concat(audio)
            })
            console.log(this.state.retrievedAudio);
        })
        .catch((err)=>console.log("Error Fetching Audio Count"))
    }

    // get a specific file
    getCorrectAudioList = () =>{
        this.setState({
            retrievedAudio:[]
        });
        getCorrectAudioListServer(24*this.state.audioCustomDays,this.state.maxAudio)
        .then((audio)=>{
            this.setState({
                retrievedAudio:this.state.retrievedAudio.concat(audio)
            })
        })
        .catch((err)=>console.log("Error Fetching Audio Count"))
    }

    // get a specific file
    getIncorrectAudioList = () =>{
        this.setState({
            retrievedAudio:[]
        });
        getWrongAudioListServer(24*this.state.audioCustomDays,this.state.maxAudio)
        .then((audio)=>{
            this.setState({
                retrievedAudio:this.state.retrievedAudio.concat(audio)
            })
        })
        .catch((err)=>console.log("Error Fetching Audio Count"))
    }

    deleteAudio = (audioId,hindiTextId)=>{
        deleteAudioWithId(audioId,hindiTextId)
        .then((resp)=>{
            if(resp.success){
                this.setState({
                    retrievedAudio:this.state.retrievedAudio.filter((audio)=>{
                        return audio._id!==audioId;
                    })
                });
            }
        })
        .catch((err)=>console.log(err));
    }

    changeVerification = (audioId)=>{
        changeVerificationResult(audioId,1)
        .then((resp)=>{
            if(resp.success){
                this.setState({
                    retrievedAudio:this.state.retrievedAudio.filter((audio)=>{
                        return audio._id!==audioId;
                    })
                });
            }
        })
        .catch((err)=>console.log(err));
    }

    render(){
        
        if(this.state.retrievedAudio!=[] && this.state.retrievedAudio!=undefined){
            var audioList = this.state.retrievedAudio.map((audio)=>{
                return(
                    <div
                        className="mt-2 pl-2 activeUserList">
                        <li key={audio._id}>
                            <h6>fileNumber: {audio.fileNumber}</h6>
                            <h6>Speaker: {audio.speaker.username}</h6>
                            <h6>Text: {audio.textInfo.hindiText}</h6>
                            <h6>Verification Result: {audio.verifiedCorrect===3?"Correct":"Wrong"}</h6>
                            <audio 
                                src={
                                    // "https://localhost:3443/"+audio.fileName+".wav"
                                    "https://datastack.ml/serverApi/audio/"+audio.fileName+".wav"
                                } 
                                controls>
                            </audio>
                        </li>
                        {/* <div className="row m-auto">
                            <div className="ml-2">
                                <h4><Button color="danger"
                                    onClick={()=>this.deleteAudio(audio._id,audio.textInfo._id)}
                                    >Delete</Button></h4>
                            </div>
                        </div> */}
                    </div>
                );
            });
        }
        return(
            <div className="mt-2">
                <div>
                    <h5><Badge>Active audios in</Badge></h5>
                </div>
                <div className="ml-3">
                    <Form onSubmit={this.getAudioCount}>
                        <div className="row">
                            <div className="pl-4">
                                <Label>
                                <Input
                                    type='radio'
                                    name="day"
                                    value="1"
                                    onChange={this.audioForDays}
                                    checked={this.state.days === "1"}
                                />
                                Last Day</Label>
                            </div>
                            <div className="pl-4">
                                <Label>
                                <Input
                                    type='radio'
                                    name="week"
                                    value="7"
                                    onChange={this.audioForDays}
                                    checked={this.state.days === "7"}
                                />
                                Last Week</Label>
                            </div>
                            <div className="pl-4">
                                <Label>
                                <Input
                                    type='radio'
                                    name="month"
                                    value="30"
                                    onChange={this.audioForDays}
                                    checked={this.state.days === "30"}
                                />
                                Last Month</Label>
                            </div>
                        </div>
                        <div className="row pl-4">
                            <div>
                            <Label>
                                <Input
                                    type='radio'
                                    name="custom"
                                    value="custom"
                                    onChange={this.audioForDays}
                                    checked={this.state.days === "custom"}
                                /></Label>
                            </div>
                            <div>
                                <Input
                                    type='text'
                                    name='inputDays'
                                    onChange={this.audioForDays}
                                    value={this.state.audioCustomDays}
                                />
                            </div>
                        </div>
                        <div className="mt-2">
                            <div className="row">
                                <h5><Badge>Number of Audio</Badge></h5>
                            </div>
                            <div className="row">
                                <div className="mt-2">
                                    <Label for="text">Max</Label>
                                </div>
                                <div className="mb-1 pb-1 col-2">
                                    <Input
                                        type="text"
                                        name="maxAudio"
                                        onChange={this.changeLimit}
                                        value={this.state.maxAudio}
                                    />
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
                <div className="m-auto">
                    <div className="row m-auto">
                        <div className="mr-2">
                            <Button 
                                color="success"
                                onClick={this.getAudioCount}>
                                Record Count</Button>
                        </div>
                        <div>
                            <Button 
                                color="primary"
                                onClick={this.getAudioVerifiedCount}>
                                Verify Count</Button>
                        </div>  
                    </div>
                    <div className="row mt-2 ml-auto">
                        <div>
                            <Button color="warning" 
                            onClick={()=>this.getIncorrectAudioList()}>
                            Wrong List</Button>
                        </div>
                        <div className="ml-2">
                            <Button color="info" 
                            onClick={()=>this.getCorrectAudioList()}>
                            Correct List</Button>
                        </div>
                    </div>
                </div>
                {/* <div className="row mt-2">
                    <h4><Button 
                    color="danger"
                    onClick={()=>this.downloadAllCorrect()}
                    >DownloadAllCorrect</Button></h4>
                </div> */}

                <div className="mt-3"
                    style={{
                        display:this.state.specificAudioDiv
                    }}>
                    <div className="row m-auto">
                        <div className="mb-1 pb-1">
                            <Input
                                type="text"
                                name="audioname"
                                onChange={this.specificAudio}
                                value={this.state.specificAudio}
                            />
                        </div>
                        <div className="ml-1">
                            <h4><Button color="info" onClick={()=>this.getSpecificAudio()}>Find File</Button></h4>
                        </div>
                    </div>
                </div>

                {/* Result */}
                <div>
                    <div className="mt-2">
                        <h5><strong>{this.state.audioCount}</strong></h5>
                        <h5><strong>{this.state.audioVerfiedCount}</strong></h5>
                    </div>
                    <div>
                        <ul>{audioList}</ul>
                    </div>
                </div>

            </div>
        );
    }
}

export default AdminAudioTools;